import React from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

const RelatedProduct = (props) => {
    return (
        <Col xs={12} className="related-product-container">
            <Row className="main-container-row">
                <Col xs={12} className="text-center">
                    <p>
                        <span className="fa fa-info-circle low-priority" />{props.children}
                    </p>
                </Col>
            </Row>
        </Col>
    );
};

RelatedProduct.propTypes = {
    children: PropTypes.node,
};

export default RelatedProduct;
